import { StarCircleOutlineIcon } from './StarCircleOutlineIcon';

/**
 * author: Google
 * id 9E034CD9-F400-4D4A-A2CB-6030313F2CED
 * name star-circle-outline
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-circle-outline.svg
 * tags
 * - Shape 
 */
export const FeatureHighlightIcon = StarCircleOutlineIcon;
export default FeatureHighlightIcon